import React from 'react';
import PostOption from './PostOption';

const PostOptions = ({ inputList }) => {
  return (
    <div className="general-options-wrap">
      {
        inputList.map(item => {
          return (
            <PostOption
              key={item.id}
              {...item}
            />
          )
        })
      }
    </div>
  )
}

export default PostOptions;